import { API_USER_ACTIVITIES_PATH } from "../constants/routes";
import { getRailsClient } from "../client";

export interface UserActivity {
  id: number;
  name: string;
  points: number;
  date: string;
  currentPoints: number;
  timeSpent: string;
}

interface UserActivitiesResponse {
  pagesNumber: number;
  list: UserActivity[];
}

export const fetchUserActivities = async (params?: {
  page?: number;
  perPage?: number;
}): Promise<UserActivitiesResponse | null> => {
  try {
    const { data } = await getRailsClient().get<UserActivitiesResponse>(API_USER_ACTIVITIES_PATH, {
      params: params ? { page: params.page, per_page: params.perPage } : undefined,
    });
    return data;
  } catch (error) {
    console.error("Error fetching user activities:", error);
    return null;
  }
};
